module.exports = __webpack_public_path__ + "img/menu.a7d620f.svg";